import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { StepperControl } from "appworks/ui/controls/standard/stepper/stepper-control";
import { formatMoneyAsCurrency } from "appworks/utils/string-formatters";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { UIDenomDisplayType } from "gameiom/wrapper/wrapper-data";
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsCreditSizeStepperControl extends StepperControl {
    protected onModelUpdateCallback: Function;

    constructor(downButton: FlexiButton, upButton: FlexiButton, valueText: FlexiText) {
        super(downButton, upButton, valueText);

        const { creditSizes } = slotModel.read().bet;

        const useDenomDisplay: boolean = gameiomModel.denomDisplay === UIDenomDisplayType.denom;
        const displayWholeNumber: boolean = gameiomModel.shouldDisplayCurrencyAsWholeNumber();
        if (useDenomDisplay && !displayWholeNumber) {
            this.stepper.formatFunction = formatMoneyAsCurrency;
        }

        this.stepper.setValues(creditSizes.values);
        this.stepper.setSelectedValue(creditSizes.currentValue);
        this.stepper.onUpdate.add((value: number) => this.onStepperUpdate(value));

        this.onModelUpdateCallback = () => this.onModelUpdate();
        slotModel.onUpdate.add(this.onModelUpdateCallback);
    }

    public destroy(): void {
        super.destroy();
        slotModel.onUpdate.remove(this.onModelUpdateCallback);
    }

    public setEnabled(enabled: boolean): void {
        const { freeBet } = slotModel.read().bet;
        super.setEnabled(!freeBet && enabled);
    }

    protected onModelUpdate(): void {
        const { creditSizes } = slotModel.read().bet;
        this.stepper.setSelectedValue(creditSizes.currentValue);
    }

    protected onStepperUpdate(currentValue: number): void {
        Services.get(SlotBetService).setCreditSize(currentValue);
    }
}
